import type { LocalizedString } from 'types/context';

/**
 * Resolve a LocalizedString to the current locale, falling back to default then empty string.
 */
export function resolveLabel(
  label: string | LocalizedString | undefined,
  locale: string
): string {
  if (!label) return '';
  if (typeof label === 'string') return label;
  return label?.translations?.[locale] || label?.default || '';
}
